<div>
    <div class="form-group">
        <div class="row">
            <label class="col-form-label col-sm-8 input-label">Related determinants:</label>
        </div>
        <div class="row">
            <div class="col-12">
                <ng-select [(ngModel)]="relatedDeterminantValues"
                           bindLabel="name"
                           bindValue="id"
                           [readonly]="true"
                           [multiple]="true"
                           [items]="relatedDeterminants"
                           ></ng-select>
            </div>
            <div class="col-sm-4 col-6"></div>
        </div>
    </div>
</div>
